// extracted by mini-css-extract-plugin
export default {"modalEditedBlock":"SlidingPuzzle_modalEditedBlock__xyxbw"};